import { useLanguage } from "@/lib/LanguageContext";

export default function Pricing() {
    const { t } = useLanguage();
    return (
        <section id="pricing" className="ps-section ps-relative-z" data-testid="pricing-section">
            <div className="ps-container">
                <div className="ps-section-head">
                    <h2 className="ps-display ps-section-title" data-split data-split-scroll data-testid="pricing-title"
                        dangerouslySetInnerHTML={{ __html: t.pricing.title }} />
                </div>

                <div className="ps-tiers" data-testid="pricing-tiers">
                    {t.pricing.tiers.map((tier, i) => (
                        <div key={i} className={`ps-tier ${tier.best ? "is-best" : ""} ps-fade`} data-testid={`tier-${i + 1}`}>
                            {tier.rec && <span className="ps-tier-rec">{tier.rec}</span>}
                            <div className="ps-tier-kin ps-mono">{tier.kin}</div>
                            <h3 className="ps-tier-title">{tier.title}</h3>
                            <p className="ps-tier-desc">{tier.desc}</p>
                            <div className="ps-tier-price">
                                {tier.price}
                                <small>{t.pricing.priceNote}</small>
                            </div>
                            <ul className="ps-tier-features">
                                {tier.features.map((f, j) => (
                                    <li key={j}>
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                            <path d="M20 6 9 17l-5-5" />
                                        </svg>
                                        <span>{f}</span>
                                    </li>
                                ))}
                            </ul>
                            <a href="#contact" className={`ps-btn ${tier.best ? "ps-btn-primary" : ""}`} data-testid={`tier-${i + 1}-cta`}>
                                <span>{t.pricing.ctaLabel}</span>
                                <span className="ps-btn-dot" />
                            </a>
                        </div>
                    ))}
                </div>
                {/* Lo que frena a alguien no suele ser el precio sino el trabajo
                    que cree que le va a tocar. Por eso la garantia va pegada a
                    los precios y no escondida en el FAQ. */}
                {t.pricing.guarantee && (
                    <div className="ps-guarantee ps-fade" data-testid="pricing-guarantee">
                        <div className="ps-guarantee-label ps-mono">{t.pricing.guarantee.label}</div>
                        <div className="ps-guarantee-items">
                            {t.pricing.guarantee.items.map((g) => (
                                <div key={g.k}>
                                    <h3 className="ps-guarantee-k">{g.k}</h3>
                                    <p className="ps-guarantee-v">{g.v}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <p className="ps-tier-note ps-fade" dangerouslySetInnerHTML={{ __html: t.pricing.note }} />
            </div>
        </section>
    );
}
